export default "__VITE_ASSET__BcWUZ25T__"